module.exports = __webpack_public_path__ + "img/search.fbc5aa2d.png";